/**
 * Printing type codes for AJAX payloads (mirror PHP veyop_parse_printing_codes / sanitize_key semantics).
 */
import type { PrintingTypeConfig } from '../stores/configStore';

export function sanitizePrintingCode(code: string): string {
  return String(code ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9_-]/g, '');
}

export function parsePrintingCodes(raw: string): string[] {
  const s = String(raw ?? '').trim();
  if (!s) {
    return [];
  }
  try {
    const decoded = JSON.parse(s) as unknown;
    if (Array.isArray(decoded)) {
      const out: string[] = [];
      for (const item of decoded) {
        const c = sanitizePrintingCode(String(item));
        if (c && !out.includes(c)) {
          out.push(c);
        }
      }
      return out;
    }
  } catch {
    // not JSON — treat as delimiter-separated
  }
  const out: string[] = [];
  for (const part of s.split(/[,;|]+/)) {
    const c = sanitizePrintingCode(part);
    if (c && !out.includes(c)) {
      out.push(c);
    }
  }
  return out;
}

/**
 * Single code to send as print.type / print_type (never a comma-separated list).
 */
export function getEffectivePrintingPayloadCode(
  selectedPrintingCode: string,
  availablePrintings: PrintingTypeConfig[],
  catalogPrintTypeField: string,
): string {
  const sel = sanitizePrintingCode(selectedPrintingCode);
  if (sel && availablePrintings.some((p) => p.printing_code === sel)) {
    return sel;
  }
  if (availablePrintings.length === 1) {
    return availablePrintings[0].printing_code;
  }
  const allowed = new Set(availablePrintings.map((p) => p.printing_code));
  const fromCatalog = parsePrintingCodes(catalogPrintTypeField);
  for (const c of fromCatalog) {
    if (allowed.has(c)) {
      return c;
    }
  }
  return fromCatalog[0] ?? '';
}

